import { isOrgAdminRole } from "../../../../smokepit/src/constants";
import type { AuthUser } from "../../context/auth";

/** Admin surfaces treat `admin` and `fybr_admin` alike. Mirrors the server's isOrgAdminRole. */
export const isOrgAdminUser = (user: AuthUser | null | undefined): boolean =>
  isOrgAdminRole(user?.organization_role ?? "");

/** FYBR staff only: the /internal tree, plus materials and sites on any organization. */
export const isFybrAdminUser = (user: AuthUser | null | undefined): boolean =>
  user?.organization_role === "fybr_admin";
